export const GET_ORG_PROFILE_INFO = 'GET_ORG_PROFILE_INFO';
export const GET_ORG_IS_PROGRESS = 'GET_ORG_IS_PROGRESS';
export const GET_ORG_REQUEST_CHANGE_INPROGRESS = 'GET_ORG_REQUEST_CHANGE_INPROGRESS';
